import MyService from '../../service';

const TransferMoneyApi = {
  create: async (transferMoney) => {
    let transfer;
    console.log('add new transferMoney ', transferMoney);
    await MyService.postRequestData('/transfer-money', transferMoney)
      .then((result) => {
        transfer = result;
      })
      .catch((err) => console.log(err));

    return transfer;
  },

  getAll: async () => {
    try {
      const { data } = await MyService.getRequestData('/transfer-money');
      return data;
    } catch (e) {
      console.error(e);
      return [];
    }
  },

  updateStatus: async (requestId, params) => {
    try {
      await MyService.putRequestData(`/transfer-money/${requestId}`, params);
    } catch (e) {
      console.error(e);
    }
  },
};

export default TransferMoneyApi;

const TYPES = [
  {
    type_id: 1,
    type_name: 'Chuyển khoản cho đối tác',
  },
  {
    type_id: 2,
    type_name: 'Chuyển khoản cho khách hàng',
  },
];

const REASONS = [
  {
    reason_id: 1,
    reason_name: 'Cọc chốt xe',
    type_id: 1,
  },
  {
    reason_id: 2,
    reason_name: 'Hoàn trả cọc của khách',
    type_id: 1,
  },
  {
    reason_id: 3,
    reason_name: 'Thanh toán công nợ',
    type_id: 1,
  },
  {
    reason_id: 4,
    reason_name: 'Hoàn cọc',
    type_id: 2,
  },
  {
    reason_id: 5,
    reason_name: 'Trả tiền thế chấp',
    type_id: 2,
  },
  {
    reason_id: 6,
    reason_name: 'Yêu cầu khác',
    type_id: 2,
  },
];

const STATUS = [
  {
    status_id: 1,
    status_name: 'Đang chờ duyệt',
  },
  {
    status_id: 2,
    status_name: 'Đang chờ chuyển khoản',
  },
  {
    status_id: 3,
    status_name: 'Chuyển khoản thành công',
  },
  {
    status_id: 4,
    status_name: 'Chuyển khoản thất bại',
  },
];
export { TYPES, REASONS, STATUS };
